import {NEW_ID} from '../../../common/constants/index.js'
import {returnOrderCodeSelector} from '../../../data/returnOrderCodes.js'

import ReturnOrderCodeForm from './ReturnOrderCodeForm.js'
import Icon from '../../../common/icons/Icon.js'
import {useSelector} from '../../../store.js'
import className from '../../../common/className.js'

export default function CodeListItem({returnOrderCodeID, isExpanded}) {
  const returnOrderCode = useSelector((state) =>
    returnOrderCodeID
      ? returnOrderCodeSelector(state, {returnOrderCodeID})
      : null,
  )

  return (
    <li
      className={className`settings-list-item clearfix ${{
        expanded: isExpanded,
      }}`}
    >
      {returnOrderCode ? (
        <div className="wrap--row">
          <div className="medium-5 columns">
            <strong className="fs-01 margin-right-5 v-align-middle">
              {returnOrderCode.code}
            </strong>
          </div>
          <div className="medium-5 columns">
            <span className="fs-01 v-align-middle text--lt-grey">
              {returnOrderCode.description}
            </span>
          </div>
          <div className="medium-2 columns align-right">
            {returnOrderCode.archive_date ? (
              <em className="fs-01 v-align-middle text--lt-grey ">Archived</em>
            ) : (
              <span className="fs-01  v-align-middle">
                <a
                  className="inline-text-button settings-list-item-button edit-url"
                  href={`#/settings/return_order_codes/${returnOrderCode.id}`}
                >
                  <Icon name="sym-edit" className="fs-01 margin-right-2" />
                  <span className="button-text">Edit</span>
                </a>
              </span>
            )}
          </div>
        </div>
      ) : (
        <div className="medium-12 columns button-wrap">
          <p>
            <a
              href={`#/settings/return_order_codes/${NEW_ID}`}
              title="Add a return code"
              className="inline-text-button no-underline add-sales-channel-url"
            >
              <Icon name="sym-add" className="fs-01 margin-right-5" />
              <span>Add a return code</span>
            </a>
          </p>
        </div>
      )}
      {isExpanded && (
        <ReturnOrderCodeForm returnOrderCodeID={returnOrderCodeID} />
      )}
    </li>
  )
}
